import { reactive, getCurrentInstance } from "vue";
import { AddToCartContext, ShopSdk, BackofficeSdk, SdkEvents } from "@one-commerce/sdk-core";
const MISSING_ORIGIN_ERROR = "MISSING_ORIGIN_ERROR";

export const useOneSdk = () => {
  const instance = getCurrentInstance();
  return instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$one;
};
export default {
  install: (app, options) => {
    if (typeof options === "undefined") {
      throw new Error("[Sztkm Mue3] " + MISSING_ORIGIN_ERROR);
    }

    const log = (...data) => {
      ((options === null || options === void 0 ? void 0 : options.debug) || false) && console.log(`[Sztkm Mue3] ${data.join(" ")}`);
    };

    const initalizeONeFrontend = (options) => {
      console.log("Setup FrontendSdk")
      const sdk = new ShopSdk(options);

      /*** EXTRA ***/
      const extraInstances = {
        context: new AddToCartContext(sdk.callFunction.bind(sdk)),
      };
      const extraUpdateInstance = payload => {
        obj.context.update(payload);
      }
      /*************/
  
      const obj = reactive({
        isInitialized: false,
        token: null,
        navigate: sdk.navigate,
        ...sdk.instances,
        ...extraInstances
      });
  
      const updateInstances = payload => {
        obj.route = payload.route;
        obj.cart.update(payload);
        obj.account.update(payload);
        obj.catalog.update(payload);
        obj.config.update(payload);
        obj.utils.update(payload);
      };
  
      sdk.channel.subscribe("one:init", payload => {
        extraUpdateInstance(payload);
        obj.isInitialized = true;
      });
  
      sdk.on(SdkEvents.UPDATE, payload => {
        log("Handling UPDATE");
        updateInstances(payload);
        extraUpdateInstance(payload);
      });
  
      app.config.globalProperties.$one = obj;
      return obj;
    };

    const initializeONeBackend = (options) => {
      console.log("Setup BackofficeSDK")
      options.context = AddToCartContext;
      const sdk = new BackofficeSdk(options);

      const obj = reactive({
        isInitialized: false,
        token: null,
        navigate: sdk.navigate,
        ...sdk.instances,
      });
  
      const updateInstances = payload => {
        obj.route = payload.route;
        obj.user.update(payload);
        obj.tenant.update(payload);
        obj.layout.update(payload);
        obj.catalog.update(payload);
        obj.orderpath.update(payload);
        obj.authorization.update(payload);
        obj.customer.update(payload);
        obj.plugin.update(payload);
      };
  
      sdk.on(SdkEvents.INIT, payload => {
        log("Handling INIT ");
  
        if (!obj.isInitialized) {
          obj.isInitialized = true;
          updateInstances(payload);
        }
      });
      sdk.on(SdkEvents.UPDATE, payload => {
        log("Handling UPDATE");
        updateInstances(payload);
      });
  
      app.config.globalProperties.$one = obj;
      return obj;
    };

    const initializeONe = ["https://backoffice-preprod.one.unity.pl", "https://login.shop"].includes(options.origin) ? initializeONeBackend : initalizeONeFrontend;

    app.config.globalProperties.initializeONe = () => initializeONe(options);
  }
};
//# sourceMappingURL=index.js.map